import React from 'react'

import useImpressionsObserver from 'helpers/useImpressionsObserver'

/** @type {import("./types").default} */
const ImpressionEvent = ({ className = '', children, event }) => {
  const { addEvent, ref } = useImpressionsObserver({
    rootMargin: '0px 0px 0px 0px',
    threshold: 0.1,
  })

  return (
    <div ref={ref} className={className} {...addEvent(event)}>
      {children}
    </div>
  )
}

export default ImpressionEvent
